export default __webpack_public_path__ + "static/media/img4.a2450710.jpg";